module.exports = __webpack_public_path__ + "img/default.1eb8c1aa.png";